import { FunctionField, FunctionFieldProps } from 'react-admin';
import { resolvePath } from '@components/fields/resolve-path';

type ExtraFields = {prefix?: string; postfix?: string}

export const TextPostfixField = (props: Partial<FunctionFieldProps> & ExtraFields) => {
  const fieldProps = { ...props };
  delete fieldProps.prefix;
  delete fieldProps.postfix;

  return (
    <FunctionField
      {...fieldProps}
      render={
        (record: any) => (
          <span>{props.prefix}{resolvePath(record, props.source || '')}{props.postfix}</span>
        )}
    />
  );
};
